/*eslint-disable */

import AccountStore from './suAccount'
import AlgorithmStore from './algorithm'
import ChatBot from './chatBot'
import ConferenceStore from './conferenceStore'
import DataStore from './dataStore'
import EmailStore from './emailStore'
import MeetingStore from './meetingStore'
import Profile from './profile'
import SuperAdminAccountStore from './saAccount'
import TaskStore from './task'
import UserStore from './userStore'
import VideoStore from './videoStore'
import Vue from 'vue';
import Vuex from 'vuex';
import aiTaskStore from './aiTaskStore'
import algoDataStore from './algoDataStore'
import authenticationStore from './authenticate'
import blogStore from './blogStore'
import botTicketStore from './botTicketStore'
import briefcaseStore from './briefcaseStore'
import chatMessageCache from './modules/chatMessageCache';
import consultPatientStore from './consultPatientStore'
import eventStore from './eventStore'
import interviewerStore from './interviewerStore'
import loader from './loaderStore'
import memberFiltersStore from './memberFiltersStore'
import memberStore from './memberStore'
import notesStore from './notesStore'
import notificationStore from './notificationStore.js';
import paperpileStore from './paperpileStore'
import paymentStore from './paymentStore.js';
import schedulerStore from './schedulerStore'
import teamUsersStore from './teamUsersStore'
import todoStore from './todoStore.js';
import tukivitaStore from './tukivitaStore'
import twoFactorStore from './twoFactorStore'
import unsubscribedStore from './unsubscribedStore'
import webinarStore from './webinarStore'
import workspaceStore from './workspaceStore'

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    loader,
    authenticationStore,
    AlgorithmStore,
    DataStore,
    AccountStore,
    TaskStore,
    SuperAdminAccountStore,
    ChatBot,
    Profile,
    UserStore,
    VideoStore,
    EmailStore,
    ConferenceStore,
    MeetingStore,
    webinarStore,
    memberStore,
    blogStore,
    memberFiltersStore,
    notesStore,
    algoDataStore,
    briefcaseStore,
    unsubscribedStore,
    aiTaskStore,
    paperpileStore,
    workspaceStore,
    consultPatientStore,
    schedulerStore,
    teamUsersStore,
    twoFactorStore,
    notificationStore,
    paymentStore,
    todoStore,
    eventStore,
    interviewerStore,
    botTicketStore,
    tukivitaStore,
    chatMessageCache
  }
})